<!--
  As of 2020-05-26, this is a copy of the Events/Event.vue template.
  We can modify it as needed to make it work for Network Registrations.
-->
<template>
  <div :class="cssClasses">
    <div class="eventInformation networkInformation">
      <v-container class="pt-0">
        <v-layout row wrap>
          <v-flex sm7 class="information">
            <h4 v-if="extract('event.open')">Register for</h4>
            <h3
              v-html="
                extract('event.content.body.title') || extract('event.name')
              "
            ></h3>
            <div
              class="event-description"
              v-html="extract('event.content.body.description')"
            ></div>
            <table
              class="event-sections"
              v-if="extract('event.content.body.sections')"
            >
              <tr
                v-for="(obj, num) in extract('event.content.body.sections')"
                v-bind:key="num"
              >
                <td class="rowLabel">
                  <h4 class="section-title">
                    {{
                      extract("event.content.body.sections." + num + ".title")
                    }}:
                  </h4>
                </td>
                <td
                  v-html="
                    extract('event.content.body.sections.' + num + '.html')
                  "
                ></td>
              </tr>
            </table>
            <div
              class="event-closing"
              v-if="extract('event.content.body.closing')"
              v-html="extract('event.content.body.closing')"
            ></div>
            <div>
              <span
                class="capacity-notice"
                v-if="!loading && availableSlots < 1"
                >The network is currently at capacity, but sign up below to be
                added to the wait list and we'll email you if a spot opens
                up.</span
              >
            </div>
          </v-flex>
          <v-flex sm4 offset-sm1 class="callout">
            <!-- IF DEFAULT ASIDE -->
            <div class="whiteBox pa-4 mb-4 hidden-xs-only" v-if="hasAside">
              <div v-if="hasAside">
                <div v-if="defaultAside">
                  <!-- <p><img src="@/assets/es/Summit_SideCallout.svg" style='max-height: 200px; max-width:100%' /></p> -->
                  <p><v-img src="@/assets/es/Summit_01@2x.jpg" /></p>
                  <p><v-img src="@/assets/es/Summit_02@2x.jpg" /></p>
                </div>
                <div v-else class="customAside">
                  <AmazeDynamicComponent
                    v-bind:template="extract('event.content.aside.html')"
                  ></AmazeDynamicComponent>
                </div>
              </div>
            </div>
            <!-- END DEFAULT ASIDE -->
            <div id="refund-dialog">
              <v-dialog v-model="dialog" max-width="500px">
                <v-btn
                  slot="activator"
                  color="primary"
                  style="display: none"
                  id="refund-dialog-button"
                  class="mb-4 mt-4 ml-0"
                >
                  Learn more about RTI's refund and cancellation policy
                </v-btn>
                <v-card>
                  <v-card-title>
                    <h3 class="headline">Refund and Cancellation Policy</h3>
                  </v-card-title>
                  <hr class="thick" />

                  <v-card-text>
                    <v-layout wrap>
                      <div class="pa-2 mb-2">
                        <p>
                          The {{ event.name }} Cancellation and Refund Policy
                          will be as follows to assure consistency and is
                          applicable to this network.
                        </p>
                        <p>
                          {{ event.name }} registration canceled online on or
                          before {{ getFormattedDate(event.refund_expiry) }} is
                          refundable if already paid, or not due if not already
                          paid. In order for your cancellation to be received,
                          email
                          <a href="mailto:educationservices@rti.org "
                            >educationservices@rti.org</a
                          >
                          no later than
                          {{ getFormattedDate(event.refund_expiry) }}.
                        </p>
                      </div>
                    </v-layout>
                  </v-card-text>

                  <v-card-actions>
                    <v-spacer />
                    <v-btn color="blue darken-1" flat @click="dialog = false"
                      >Cancel</v-btn
                    >
                  </v-card-actions>
                </v-card>
              </v-dialog>
            </div>
          </v-flex>
        </v-layout>
      </v-container>
    </div>

    <!-- BEGIN THE FORMATIONING -->
    <div class="registrationForm" v-if="!loading">
      <div class="text-xs-center" v-if="!extract('event.open')">
        <h4>Registration is closed for this network.</h4>
      </div>
      <v-form
        ref="regForm"
        v-model="valid"
        v-if="
          !this.extract('event.content.form.custom') && extract('event.open')
        "
      >
        <v-container>
          <v-layout row wrap>
            <v-flex md6 mr-4>
              <h3>
                Registration
                <small>Required fields <span class="star">*</span></small>
              </h3>

              <h5 v-if="!registrationIsSingle">
                School &amp; Team Information
              </h5>

              <v-text-field
                v-model="districtName"
                required
                :rules="rules.district"
              >
                <template slot="label"
                  >District Name<span class="star">*</span></template
                >
              </v-text-field>

              <v-text-field v-model="schoolName" required :rules="rules.school">
                <template slot="label"
                  >School Name<span class="star">*</span></template
                >
              </v-text-field>

              <h5>School Address</h5>

              <AmazeAddress :address="schoolAddress"></AmazeAddress>

              <h5>Billing Address (check if the same as the above)</h5>
              <v-checkbox
                v-model="billingSame"
                :label="`Use School Address`"
              ></v-checkbox>

              <AmazeAddress
                v-if="!billingSame"
                :address="billingAddress"
              ></AmazeAddress>

              <h5>Contact for Invoice Payments</h5>

              <p>
                The Contact for Invoice Payments will receive the email
                confirmation and an invoice email that contains payment
                information.
              </p>

              <v-text-field
                v-model="registrant[0].name"
                required
                :rules="rules.required"
              >
                <template slot="label"
                  >Name<span class="star">*</span></template
                >
              </v-text-field>

              <AmazeEmailAddressInput
                v-model="registrant[0].email"
                :required="true"
              >
                <template slot="label">E-mail</template>
              </AmazeEmailAddressInput>

              <v-text-field
                v-model="registrant[0].extra_attributes.phoneNumber"
              >
                <template slot="label">Phone Number</template>
              </v-text-field>

              <div v-if="membershipOptions" id="MembershipOptionsContainer">
                <h5>Membership Option</h5>
                <p>Please select either of these options.</p>

                <v-radio-group
                  v-model="membershipOption"
                  required
                  :rules="rules.option"
                >
                  <v-radio
                    v-for="n in membershipOptions"
                    :key="n.name"
                    :label="n.description"
                    :value="n.value"
                    required
                  >
                    <template v-slot:label>
                      <div class="radioLabel membershipOptionLabel">
                        <span class="membershipOptionName">{{ n.name }}</span>
                        <p
                          class="membershipOptionDescription"
                          v-html="n.description"
                        ></p>
                      </div>
                    </template>
                  </v-radio>
                </v-radio-group>
              </div>

              <div
                v-if="
                  buildYourOwnOptions && membershipOption == 'Build Your Own'
                "
                id="MembershipOptionsContainer"
              >
                <h5>Build Your Own Options</h5>
                <p>
                  Please select at least one option from below. You may choose
                  multiple options.
                </p>

                <v-checkbox
                  v-for="n in buildYourOwnOptions"
                  :key="n.name"
                  v-model="buildYourOwnOption"
                  :label="n.description"
                  :value="n.value"
                  :rules="byoRule"
                ></v-checkbox>
              </div>

              <div
                v-if="addOnOptions && addOnOptions.length"
                id="MembershipOptionsContainer"
              >
                <h5>Add-On Options</h5>
                <p>
                  Please select all the add-ons your school is considering. RTI
                  will reach out to the listed point of contact to provide
                  additional information.
                </p>
                <v-checkbox
                  v-for="n in addOnOptions"
                  :key="n.name"
                  v-model="addOnOption"
                  :label="n.description"
                  :value="n.value"
                >
                  <template v-slot:label>
                    <div class="radioLabel membershipOptionLabel">
                      <span class="membershipOptionName"
                        >{{ n.name }} - {{ n.cost }}</span
                      >
                      <p
                        v-if="n.details"
                        class="membershipOptionDescription"
                        v-html="n.details"
                      ></p>
                    </div>
                  </template>
                </v-checkbox>
              </div>
              <div
                v-if="
                  addOnOption &&
                  addOnOption.indexOf('2026 Early College Summit') > -1
                "
              >
                <h5>Early College Summit Registration</h5>
                <p>
                  Please enter the number of attendees below. The pre-paid
                  registration instructions will be shared for the Early College
                  Summit once the registration is available. You may enter up to
                  15 attendees.
                </p>
                <v-text-field
                  v-model="ecsCount"
                  type="number"
                  min="0"
                  max="20"
                  :rules="ecsRule"
                  @blur="
                    () => {
                      if (ecsCount > 15) {
                        ecsCount = 15;
                      }
                      if (ecsCount < 0) {
                        ecsCount = 0;
                      }
                    }
                  "
                />
              </div>
              <div
                v-if="moreInfos && moreInfos.length"
                id="MembershipOptionsContainer"
              >
                <h5>Additional Information</h5>
                <p>
                  If you would like to learn more about the following options,
                  select them and a member of the RTI team will reach out to
                  you. These options will not be included on the invoice for the
                  Early College Network.
                </p>
                <v-checkbox
                  v-for="n in moreInfos"
                  :key="n.name"
                  v-model="moreInfo"
                  :label="n.description"
                  :value="n.value"
                >
                  <template v-slot:label>
                    <div class="radioLabel membershipOptionLabel">
                      <span class="membershipOptionName"
                        >{{ n.name }} - {{ n.cost }}</span
                      >
                      <p
                        v-if="n.details"
                        class="membershipOptionDescription"
                        v-html="n.details"
                      ></p>
                    </div>
                  </template>
                </v-checkbox>
              </div>

              <h5>Attendee Information</h5>
              <p>
                Please enter the registration information (name, email, and
                role) for each person on your school team.
              </p>

              <h5>Principal</h5>
              <v-text-field
                v-model="registrant[1].name"
                required
                :rules="rules.name"
              >
                <template slot="label">
                  Principal Name<span class="star">*</span>
                </template>
              </v-text-field>
              <AmazeEmailAddressInput v-model="registrant[1].email">
                <template slot="label">Principal E-mail</template>
              </AmazeEmailAddressInput>

              <h5>Lead Counselor</h5>
              <v-text-field
                v-model="registrant[2].name"
                :rules="attendeeIsRequired('Counselor') ? rules.name : []"
              >
                <template slot="label">
                  Lead Counselor Name<span
                    class="star"
                    v-if="attendeeIsRequired('Counselor')"
                    >*</span
                  >
                </template>
              </v-text-field>
              <AmazeEmailAddressInput
                v-model="registrant[2].email"
                :required="attendeeIsRequired('Counselor')"
              >
                <template slot="label">Lead Counselor E-mail</template>
              </AmazeEmailAddressInput>

              <h5>College Liaison</h5>
              <v-text-field
                v-model="registrant[3].name"
                :rules="attendeeIsRequired('Counselor') ? rules.name : []"
              >
                <template slot="label">
                  College Liaison Name<span
                    class="star"
                    v-if="attendeeIsRequired('Counselor')"
                    >*</span
                  >
                </template>
              </v-text-field>
              <AmazeEmailAddressInput
                v-model="registrant[3].email"
                :required="attendeeIsRequired('Counselor')"
              >
                <template slot="label">College Liaison E-mail</template>
              </AmazeEmailAddressInput>
              <h5>Lead Teacher</h5>
              <v-text-field
                v-model="registrant[4].name"
                :rules="attendeeIsRequired('Teacher') ? rules.name : []"
              >
                <template slot="label">
                  Lead Teacher Name<span
                    class="star"
                    v-if="attendeeIsRequired('Teacher')"
                    >*</span
                  >
                </template>
              </v-text-field>
              <AmazeEmailAddressInput
                v-model="registrant[4].email"
                :required="attendeeIsRequired('Teacher')"
              >
                <template slot="label">Lead Teacher E-mail</template>
              </AmazeEmailAddressInput>
            </v-flex>

            <v-flex xs12 sm12 md12 lg12 class="mt-20">
              <div class="submit-wrapper" v-if="registrants > 0">
                <div class="submit-success" v-if="this.submittedSuccessfully">
                  <h5>Success!</h5>
                  <p>
                    <strong
                      >Thank you for registering for the
                      <span
                        v-html="
                          extract('event.content.body.title') ||
                          extract('event.name')
                        "
                      ></span
                      >!</strong
                    >
                    {{ primaryContact }} should receive a confirmation email
                    shortly. If {{ primaryContact }} does not receive an email,
                    please contact
                    <a :href="'mailto:' + contactAddress">{{
                      contactAddress
                    }}</a
                    >.
                  </p>
                </div>
                <div class="submit-incomplete" v-else>
                  <h5 v-if="terms || acknowledgement">Terms and Conditions</h5>
                  <div v-if="terms || acknowledgement">
                    <div id="netTermsWrapper">
                      <AmazeTermsViewer :src="terms"></AmazeTermsViewer>
                    </div>
                    <div
                      v-if="acknowledgement"
                      v-html="acknowledgement"
                      id="acknowledgement"
                    ></div>
                    <div v-if="acknowledgement">
                      <v-checkbox
                        required
                        :rules="rules.acknowledge"
                        v-model="acknowledge"
                        :disabled="acknowledge"
                        :label="`I acknowledge that I have read and accept the terms and conditions.`"
                      ></v-checkbox>
                    </div>
                  </div>
                  <v-btn
                    v-if="!submitted"
                    class="ml-0"
                    color="primary"
                    @click="submitRegistration()"
                    >Submit Registration</v-btn
                  >
                  <v-progress-circular v-else indeterminate />
                </div>
              </div>
            </v-flex>
          </v-layout>
        </v-container>
      </v-form>
    </div>

    <!-- END THE FORMATIONING -->
  </div>
</template>
<style scoped lang="scss"></style>
<script>
import registrationMixin from "@/mixins/registrationMixin.js";

export default {
  mixins: [registrationMixin],
  data() {
    return {
      dialog: false,
      loading: true,
      valid: false,
      submitted: false,
      acknowledge: false,

      availableSlots: 0,
      maxRegistrants: 0,
      totalAttendees: 0,

      ecsCount: 0,

      schoolName: "",
      districtName: "",
      stateName: "",

      schoolAddress: {
        street: null,
        city: null,
        state: null,
        zip: null
      },

      billingSame: false,
      cachedBilling: null,
      billingAddress: {
        street: null,
        city: null,
        state: null,
        zip: null
      },

      membershipOption: null,

      membershipOptions: [
        {
          name: "Standard Membership - $3,950",
          value: "Standard ($3950)",
          description:
            "All networking and professional learning for Principals, Counselors, College Liaisons, Teachers, and Students",
          cost: 3950
        },
        {
          name: "Build Your Own Membership - Cost based on options chosen",
          value: "Build Your Own",
          description:
            "Select the individual options you want from the Build Your Own Membership Options",
          cost: 0
        }
      ],

      buildYourOwnOption: [],
      buildYourOwnOptions: [
        {
          name: "Principal and Assistant Principal Option - $1,700",
          value: "Principal and Assistant Principal Option ($1,700)",
          description: "Principal and Assistant Principal Option - $1,700",
          cost: 1700
        },
        {
          name: "Counselor/Liaison (up to 2) Option - $1,500",
          value: "Counselor/Liaison (up to 2) Option ($1,500)",
          description: "Counselor/Liaison (up to 2) Option - $1,500",
          cost: 1500
        },
        {
          name: "Instructional Staff Option - $1,300",
          value: "Instructional Staff Option ($1,300)",
          description: "Instructional Staff Option - $1,300",
          cost: 1300
        },
        {
          name: "Student Option - $500",
          value: "Student Option ($500)",
          description: "Student Option - $500",
          cost: 500
        }
      ],

      addOnOption: [],
      addOnOptions: [
        {
          name: "2026 Early College Summit",
          value: "2026 Early College Summit",
          description: "2026 Early College Summit",
          details:
            "<p>Includes registration to 2-day Early College Summit to be held in Winston-Salem, NC on June 9-10, 2026</p><ul><li>Once ECN membership is processed, the ECN team will follow up to request names and contact information of staff who will attend the summit</li></ul>",
          cost: "$550 per person"
        }
      ],

      moreInfo: [],
      moreInfos: [
        {
          name: "School-based Professional Development and Coaching Support",
          value: "School-based Professional Development and Coaching Support",
          description: "Instructional Coaching",
          cost: "$28,600",
          details:
            "<p>Customized professional learning and coaching provided to school teams on-site</p><ul><li>Up to 6 on-site professional learning workshops</li><li>Up to 6 on-site coaching days </li><li>Support can be tailored to needs of school staff. Possible topics for focus include:<ol><li>Student-Centered Learning Practices </li><li>Integrating AI into Instruction</li><li>Supporting First Generation Students</li><li>Supporting Multilingual Learners</li></ol></li></ul><p>***INVOICED SEPARATELY***</p>"
        },
        {
          name: "Virtual Professional Development and Coaching Support",
          value: "Virtual Professional Development and Coaching Support",
          description: "Virtual Professional Development and Coaching Support",
          details:
            "<p>Customized professional learning and coaching provided to school teams virtually</p><ul><li>Up to 6 virtual professional learning workshops</li><li>Up to 6 virtual coaching days </li><li>Support can be tailored to needs of school staff. Possible topics for focus include:<ol><li>Student-Centered Learning Practices </li><li>Integrating AI into Instruction</li><li>Supporting First Generation Students</li><li>Supporting Multilingual Learners</li></ol></li></ul><p>***INVOICED SEPARATELY***</p>",
          cost: "$9,900"
        }
      ],

      roles: [
        "Principal",
        "Lead Teacher",
        "Lead Counselor",
        "College Liaison",
        "Other"
      ],

      registrants: 4,
      numRegistrants: 4,
      registrant: [
        {
          name: "",
          email: null,
          role: "Contact for Invoice Payments",
          extra_attributes: {
            phoneNumber: null
          }
        },
        {
          name: "",
          email: null,
          role: "Principal"
        },
        {
          name: "",
          email: null,
          role: "Lead Counselor"
        },
        {
          name: "",
          email: null,
          role: "College Liaison"
        },
        {
          name: "",
          email: null,
          role: "Lead Teacher"
        }
      ],
      submittedSuccessfully: false,
      rules: {
        name: [(v) => !!v || "Name is required."],
        email: [
          (v) => !!v || "Email is required.",
          (v) => /@/.test(v) || "Please enter a valid email."
        ],
        option: [(v) => !!v || "Membership Option is required."],
        role: [(v) => !!v || "Role is required."],
        school: [(v) => !!v || "School name is required."],
        district: [(v) => !!v || "District name is required."],
        state: [(v) => !!v || "State is required."],
        size: [(v) => !!v || "Team size is required."],
        acknowledge: [(v) => !!v || "Please accept the terms and conditions."]
      },
      event: {}
    };
  },
  watch: {
    membershipOption: function (newVal, oldVal) {
      // Clear out the BYO selections if something other than Build your own is chosen.
      if (newVal !== "Build Your Own") {
        this.buildYourOwnOption = [];
      }
    },
    buildYourOwnOption: {
      handler: function (newVal, oldVal) {},
      deep: true
    },
    billingSame: function (newVal, oldVal) {
      if (newVal) {
        this.cachedBilling = this.billingAddress;
        // Billing is same as school.
        this.billingAddress = this.schoolAddress;
      } else {
        if (this.cachedBilling) {
          this.billingAddress = this.cachedBilling;
        } else {
          this.billingAddress = this.defaultSchool;
        }
      }
    }
  },
  computed: {
    primaryContact() {
      return this.registrant[0].name || "Contact for Invoice Payments";
    },
    defaultSchool() {
      return {
        street: null,
        city: null,
        state: null,
        zip: null
      };
    },
    content() {
      // var defaults = {};
      return event.content ? event.content : false;
    },
    showWaiver() {
      // By default, we should be showing the waiver. However, if the waiver meta entry is set
      // to false, that indicates we should not show the waiver.
      return this.extract("event.content.meta.waiver", true);
    },
    registrationIsSingle() {
      return false;
    },
    registrantSlots() {
      let slots = [];
      for (let i = 1; i <= this.maxRegistrants; i++) {
        if (i === 1) {
          slots.push({ text: i + " attendee", value: i });
        } else {
          slots.push({ text: i + " attendees", value: i });
        }
      }
      return slots;
    },
    loaded() {
      return !this.loading;
    },
    showSubmitPrompt() {
      return !this.submittedSuccessfully && this.registrants > 0;
    },
    byoRule() {
      if (this.membershipOption === "Build Your Own") {
        return [
          this.buildYourOwnOption.length > 0 ||
            "At least one item should be selected"
        ];
      } else {
        return true;
      }
    },
    ecsRule() {
      if (
        this.addOnOption.indexOf("2026 Early College Summit") > -1 &&
        this.ecsCount <= 0
      ) {
        return ["Please enter the number of attendees for the ECS."];
      } else {
        return true;
      }
    }
  },
  methods: {
    attendeeIsRequired(simpleRole) {
      if (this.membershipOption === "Build Your Own") {
        return (
          this.buildYourOwnOption.filter((opt) => opt.includes(simpleRole))
            .length > 0
        );
      }

      // This is otherwise the Standard Option, and all the things are required.
      return true;
    },
    attendeeRules(ruleName, fieldName) {
      if (this.membershipOption === "Build Your Own") {
        return [
          this.buildYourOwnOption.length > 0 ||
            "At least one item should be selected"
        ];
      } else {
        return true;
      }
    },
    initializeSlots() {
      let backup = this.registrant;
      this.registrant = [];
      for (let person = 0; person < this.registrants; person++) {
        if (backup[person]) {
          this.registrant[person] = backup[person];
        } else {
          this.registrant[person] = {
            name: "",
            email: null,
            role: null
          };
        }
      }
    },
    // TODO: Validation needs more work.
    customValidation() {
      if (!this.$refs.regForm.validate()) {
        // Early exit if it doesn't pass validation rules.
        return false;
      }

      if (
        this.membershipOption === "Build Your Own" &&
        this.buildYourOwnOption.length < 1
      ) {
        // Build your own so we need at least 1 build your own selection.
        return false;
      }

      if (
        this.addOnOption.indexOf("2026 Early College Summit") > -1 &&
        this.ecsCount < 1
      ) {
        return false;
      }

      return true;
    },
    submitRegistration() {
      // TODO: Validation needs more work.
      if (this.customValidation()) {
        this.submitted = true;
        // The principal is registrant 1 (i.e. 0 index) and must accept terms
        // to submit.
        this.registrant[0].terms = this.acknowledge;

        const registrants = this.registrant.map(function (reg) {
          if (reg.email === null || reg.email.length < 1) {
            reg.email = "not provided";
          }

          if (reg.name === null || reg.name.length < 1) {
            reg.name = "not provided";
          }

          return reg;
        });

        let data = {
          school: this.schoolName,
          district: this.districtName,
          state: this.schoolAddress.state,
          team_total: this.registrants,
          registration_event_id: this.extract("event.id"),
          // registration_team_member: this.registrant,
          registration_team_member: registrants,
          single_registration: false,
          extra_attributes: {
            "School Address": this.schoolAddress,
            "Billing Address": this.billingAddress,
            "Membership Option": this.membershipOption,
            "Build Your Own Option":
              this.membershipOption === "Build Your Own"
                ? this.buildYourOwnOption
                : "n/a",
            "Add-On Option(s)": this.addOnOption,
            "More Info": this.moreInfo,
            "ECS Registration":
              this.addOnOption.indexOf("2026 Early College Summit") > -1
                ? this.ecsCount
                : 0
          }
        };

        this.$http.post("registrations", data).then(
          (response) => {
            this.submittedSuccessfully = true;
          },
          (response) => {
            this.submitted = false;
            this.$store.commit("updateMessage", {
              message:
                "There was a problem saving your registration. Please try again or contact support.",
              snackbar: true
            });
          }
        );
      } else {
        this.$store.commit("updateMessage", {
          message: "Required fields are missing. Please review the form.",
          snackbar: true
        });
      }
    }
  },
  mounted() {
    this.$http
      .get(
        "event/" +
          (this.$route.params.slug || this.$route.path.split("/").pop())
      )
      .then(
        (response) => {
          this.event = response.data.data[0];

          this.totalAttendees = this.extract("event.total_attendees") || 0;
          this.maxAttendees = this.extract("event.max_attendees") || 0;

          this.availableSlots = Math.max(
            0,
            this.maxAttendees - this.totalAttendees
          );

          this.maxRegistrants = this.extract("event.max_per_team");
          // If we need to limit registration to only accept the max number of slots, we can use the following logic:
          // Math.min(this.extract('event.max_per_team'), (this.maxAttendees - this.totalAttendees));

          var fields = this.extract("event.content.form.fields");

          if (fields) {
            for (const key in fields) {
              var field = fields[key];
              // Set defaults.
              if (field.hasOwnProperty("default")) {
                this[key] = field.default;
              }
              // Set values.
              if (field.hasOwnProperty("values")) {
                this[key] = field.values;
              }
            }
          }

          if (this.maxRegistrants === 1) {
            // Single registration, set-up initial object to avoid null object errors.
            this.registrant.push({ name: "", email: null, role: null });
            this.registrants = 1;
          }

          this.loading = false;
          // eslint-disable-next-line handle-callback-err
        },
        (error) => {
          console.log("Error: ", error);
          this.$router.push("/404");
        }
      );
  }
};
</script>
